import { FeatureBlock } from '@af/design-system-docs-ui/feature-block';
import { FeatureBlockGrid } from '@af/design-system-docs-ui/feature-block-grid';
import { personality } from "../../../../src/pages/rovo-ui/voice-and-tone/_content/_personality";
import * as React from 'react';
export default {
  FeatureBlock,
  FeatureBlockGrid,
  personality,
  React
};